import React from 'react';
import { ShieldAlert } from 'lucide-react';

const ComplianceBanner = () => {
  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-black border-b border-white/10 py-1.5 px-3 min-h-[30px] sm:min-h-[34px] flex items-center"
      data-testid="compliance-banner"
      role="region"
      aria-label="Compliance and age requirement notice"
    >
      <div className="w-full max-w-7xl mx-auto flex items-center justify-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-white/80 font-medium whitespace-nowrap overflow-hidden">
        <ShieldAlert className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-pink-400 flex-shrink-0" />
        <strong className="text-white">21+ event</strong>
        <span className="text-white/40">·</span>
        <span className="hidden sm:inline">Valid government-issued ID required at entry</span>
        <span className="sm:hidden">Valid ID required</span>
        <span className="text-white/40">·</span>
        <span>Drink Responsibly</span>
        <span className="text-white/40 hidden md:inline">·</span>
        <span className="hidden md:inline">Tickets are non-refundable</span>
      </div>
    </div>
  );
};

export default ComplianceBanner;
